function createRange(min, max, step) {
  const result = [];
  let value = min;
  while (value <= max) {
    result.push(value);
    value += step;
  }
  return result;
}
export {
  createRange
};
//# sourceMappingURL=createRange.js.map
